import * as TK from 'components/profile/PostCreationButton/translations/constants';
import { Translations } from 'translations/types';

export const postCreationButtonEnUsLocale: Translations = {
  [TK.POST_CREATION_BUTTON_LABEL]: 'Write a New Post',
};
